import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { logger } from '../logging';
import { config } from '../config';

// Clear log file on browser startup/refresh/HMR
fetch(`${config.apiUrl}/api/log/clear`, { method: 'POST' })
  .catch(() => {}); // Ignore errors if server not ready

// Global error handlers
window.addEventListener('error', (event) => {
  const stack = event.error?.stack ?? `at ${event.filename}:${event.lineno}`;
  logger.error('Window', `${event.message}\n    ${stack}`);
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  if (reason instanceof Error) {
    const stack = reason.stack?.split('\n').slice(0, 5).join('\n    ') ?? '';
    logger.error('Promise', `Unhandled rejection: ${reason.message}\n    ${stack}`);
  } else {
    logger.error('Promise', `Unhandled rejection: ${String(reason)}`);
  }
});

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
